import config from '../assets/images/config.json'

const desc = '《天下：万象》预约开启！三端互通，逆天改命'
const imgUrl = `${config.tx_share_1.src}.png`

// 通用分享
export const shareConfig = () => {
    const titleList = [
        '天下在手，万象更新！预约万象，瓜分千万奖池！',
        '三端互通，逆天改命！预约万象，瓜分千万奖池！',
        '万象启程，不负少侠！千万奖池，每抽必中好礼！',
    ]

    const randomIndex = Math.floor(Math.random() * titleList.length)
    return {
        title: titleList[randomIndex],
        desc,
        imgUrl
    }
}

// 组队邀请
export const inviteShareConfig = () => {
    const titleList = [
        '【组队】少侠，就差你了！加入小队，领永久时装！',
        '【组队】什么？组队可领永久时装！点击即可入队',
        '【组队】即将发车！同游万象，永久时装免费领！',
        '【组队】快上车！小队n等1，一起来领永久时装！',
    ]
    const randomIndex = Math.floor(Math.random() * titleList.length)
    return {
        title: titleList[randomIndex],
        imgUrl: `${config['80058_4'].src}.png`
    }
}

// 抽奖助力
export const choujiangShareConfig = () => {
    const shareConfigMap = [
        {
            title: '好友@你助力，瓜分千万奖池，每抽必中，绝不空军！',
            imgUrl: [
                `${config['80059_4'].src}.png`,
                `${config['share_tx_2'].src}.png`,
                `${config['56088_100w_4'].src}.png`,
            ]
        },
        {
            title: '求助力！我在抽iPhone 17 pro，一起试试手气~',
            imgUrl: [`${config['80043_4'].src}.png`]
        },
        {
            title: '少侠助我！玉玑子雕像限时开送，把大荒最帅男人抱回家',
            imgUrl: [`${config['80044_4'].src}.png`]
        },
        {
            title: '兄弟速来！全新盒子免费送，更有千万奖池，每抽必中奖！',
            imgUrl: [`${config['80050_4'].src}.png`]
        },
        {
            title: '奶茶自由，天下请客！为我助力，一起喝冬天的第一杯奶茶~',
            imgUrl: [`${config['80060_4'].src}.png`]
        },
        {
            title: '少侠求助力~千元油卡免费送，一路相伴，一起“加油”！',
            imgUrl: [`${config['80046_4'].src}.png`]
        },
    ]
    const randomIndex = Math.floor(Math.random() * shareConfigMap.length)
    const tarShare = shareConfigMap[randomIndex]
    let randomImgUrlIndex = tarShare.imgUrl.length > 1 ? Math.floor(Math.random() * tarShare.imgUrl.length) : 0
    return {
        title: tarShare.title,
        imgUrl: tarShare.imgUrl[randomImgUrlIndex]
    }
}

export const jumpLinkObj = {
    officialWeb: 'https://tx26.163.com/'
}

const qrBaseUrl = 'https://g20.gsf.netease.com/h5_qr_202510131546'
const qrBaseUrlRCL = 'https://g20.gsf.netease.com/h5_qr_202510202035_RCL'
export const qrObj = {
    default: {
        hutong: 'https://g20.gsf.netease.com/h5_qr_202510212123' + '/qr_hutong.jpg',
        saiji: qrBaseUrl + '/qr_saiji.png',
    },
    RCL: {
        hutong: 'https://g20.gsf.netease.com/h5_qr_202510221407_RCL' + '/qr_hutong.jpg',
        saiji: qrBaseUrlRCL + '/saiji.jpg',
    },
}